import { render, staticRenderFns } from "./TextControl.vue?vue&type=template&id=4e588f89&scoped=true&"
import script from "./TextControl.vue?vue&type=script&lang=js&"
export * from "./TextControl.vue?vue&type=script&lang=js&"
import style0 from "./TextControl.vue?vue&type=style&index=0&id=4e588f89&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e588f89",
  null
  
)

export default component.exports